import { apiGet, apiPost } from './api';

export interface BotAvatarAssignTask {
  id: number;
  taskId: string;
  pageSize: number;
  botFilterIds: string | null;
  skipNamed: number;
  skipWithAvatar: number;
  syncToPlatform: number;
  totalCount: number;
  processedCount: number;
  updatedCount: number;
  nicknameSetCount: number;
  platformSyncedCount: number;
  platformFailedCount: number;
  skippedCount: number;
  failedCount: number;
  cursorPosition: number;
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
  errorMessage: string | null;
  operator: string | null;
  startTime: string | null;
  endTime: string | null;
  createTime: string;
  updateTime: string;
}

export interface CreateRequest {
  pageSize?: number;
  botFilterIds?: string;
  syncToPlatform?: boolean;
}

export interface TaskListPage {
  list: BotAvatarAssignTask[];
  total: number;
  page: number;
  pageSize: number;
}

export async function createAssignTask(req: CreateRequest): Promise<{ taskId: string; status: string }> {
  const res = await apiPost<{ code: number; data: { taskId: string; status: string }; msg?: string }>(
    '/api/bot-avatar-assign/create', req
  );
  if (res.code !== 0) throw new Error(res.msg || '创建任务失败');
  return res.data;
}

export async function getAssignTask(taskId: string): Promise<BotAvatarAssignTask> {
  const res = await apiGet<{ code: number; data: BotAvatarAssignTask; msg?: string }>(
    `/api/bot-avatar-assign/${taskId}`
  );
  if (res.code !== 0) throw new Error(res.msg || '查询任务失败');
  return res.data;
}

export async function cancelAssignTask(taskId: string): Promise<void> {
  const res = await apiPost<{ code: number; msg?: string }>(
    `/api/bot-avatar-assign/${taskId}/cancel`, {}
  );
  if (res.code !== 0) throw new Error(res.msg || '取消任务失败');
}

export async function listAssignTasks(page = 1, pageSize = 20): Promise<TaskListPage> {
  const res = await apiGet<{ code: number; data: TaskListPage; msg?: string }>(
    `/api/bot-avatar-assign/list?page=${page}&pageSize=${pageSize}`
  );
  if (res.code !== 0) throw new Error(res.msg || '查询任务列表失败');
  return res.data;
}
